import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { t } from 'i18next';

import { type JobEventSimulation } from './JobEventSimulation';
import {
  COLUMN_COUNT,
  EventCells,
  HeaderRow,
  stripedRowSx,
  tableSx,
} from './jobEventsTableShared';

interface JobEventsSingleTableProps {
  events: JobEventSimulation[];
  loading: boolean;
  error: boolean;
}

export default function JobEventsSingleTable({
  events,
  loading,
  error,
}: JobEventsSingleTableProps) {
  return (
    <TableContainer component={Paper} sx={tableSx}>
      <Table size="small" stickyHeader>
        <TableHead>
          <HeaderRow />
        </TableHead>
        <TableBody>
          {error && (
            <TableRow>
              <TableCell
                colSpan={COLUMN_COUNT}
                align="center"
                color="error"
                sx={{ py: 0.5 }}
              >
                {t('error_messages.job_events.failed_to_simulate')}
              </TableCell>
            </TableRow>
          )}
          {!loading && !error && events.length === 0 && (
            <TableRow>
              <TableCell
                colSpan={COLUMN_COUNT}
                align="center"
                sx={{ py: 0.5, color: 'text.secondary' }}
              >
                {t('admin.job_geo_debug.no_job_events')}
              </TableCell>
            </TableRow>
          )}
          {!loading &&
            !error &&
            events.map((event, index) => (
              <TableRow
                key={`${event.id ?? index}-${event.eventName}`}
                sx={{
                  '&:hover': {
                    backgroundColor: (theme) => theme.palette.action.hover,
                  },
                  ...stripedRowSx(index),
                }}
              >
                <EventCells event={event} />
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
